import { SVGProps } from "react";
import { motion } from "framer-motion";

const CheckCircle = (
  props: SVGProps<SVGSVGElement> & { animate?: boolean }
) => (
  <motion.svg
    width={props.width || 16}
    height={props.height || 16}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className || ""}
  >
    <path
      d="M20.75 10.75C20.75 5.22715 16.2728 0.75 10.75 0.75C5.22715 0.75 0.75 5.22715 0.75 10.75C0.75 16.2728 5.22715 20.75 10.75 20.75C16.2728 20.75 20.75 16.2728 20.75 10.75Z"
      stroke={props.stroke || "#6EBD7F"}
      stroke-width="1.5"
    />
    <path
      d="M6.75 11.5C6.75 11.5 8.35 12.4125 9.15 13.75C9.15 13.75 11.55 8.5 14.75 6.75"
      stroke={props.stroke || "#6EBD7F"}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </motion.svg>
);
export default CheckCircle;
